import { FC } from 'react';
import { capitalCase } from 'change-case';
import { Tr } from '@utils';
import { Organization } from '@services';
import { Box, Grid } from '@mui/material';
import { VoltaageModalDialog, IVoltaageModalDialogProps, StripedTableCell } from '@components/common';

export interface IClientAccountViewDialogProps extends IVoltaageModalDialogProps {
	entity?: Organization;
}

export const ClientAccountViewDialog: FC<IClientAccountViewDialogProps> = ({ entity, ...props }) => {
	return (
		<VoltaageModalDialog title={<Tr.Portal path="client-account.add-edit-view-modal-title" />} dividers {...props}>
			{entity ? (
				<Box sx={{ paddingX: 10, paddinTop: 3, paddingBottom: 5 }}>
					<Grid container>
						<StripedTableCell title={<Tr.Portal path="client-account.client-account-name" />}>
							{entity.name || '-'}
						</StripedTableCell>
						<StripedTableCell title={<Tr.Portal path="client-account.vat-code" />}>{entity.vat || '-'}</StripedTableCell>
						<StripedTableCell title={<Tr.Portal path="client-account.domain-name" />} greyBg>
							{entity.domain || '-'}
						</StripedTableCell>
						<StripedTableCell title={<Tr.Portal path="client-account.address" />} greyBg>
							{entity.address || '-'}
						</StripedTableCell>
						{/* TODO: remove latitude and longitute. From the json with locales also! */}
						{/* <StripedTableCell title={<Tr.Portal path="client-account.latitude" />}>{entity.latitude || '-'}</StripedTableCell>
						<StripedTableCell title={<Tr.Portal path="client-account.longitude" />}>{entity.longitude || '-'}</StripedTableCell> */}
						{(entity.permissions.length % 2 ? [...entity.permissions, undefined] : entity.permissions).map((permission, i) => {
							return (
								<StripedTableCell
									key={`permission-${permission}-${i}`}
									title={permission ? <Tr.Portal path="roles.capability" /> : null}
									greyBg={!(i % 4 < 2)}
								>
									{permission ? capitalCase(permission.split('_').join(' ')) || '-' : null}
								</StripedTableCell>
							);
						})}
					</Grid>
				</Box>
			) : null}
		</VoltaageModalDialog>
	);
};
